import React from "react";

const LazyRunRedirect = React.lazy(() => import("./RunRedirect").then((m) => ({ default: m.RunRedirect })));

export default LazyRunRedirect;
